import { FLOW_STEP_PATHS } from '../constants/paths';

/**
 * Get the URL for Stakeholder card on Summary Pages
 * based on country and stakeholder data
 *
 * Returns the URL ready to be used (with basePath attached to it)
 */
export default (
  country,
  region,
  {
    hasControlOverManagementStakeholders,
    isApplicant,
    isApplicantOnly,
    isEntityTypePartnership,
    isSoleTraderOrSoleProprietorship,
  },
  basePath,
) => {
  if (isSoleTraderOrSoleProprietorship) {
    return `${basePath}/${FLOW_STEP_PATHS.SOLE_TRADER_PATH}`;
  } else if (region === 'us') {
    return `${basePath}/${FLOW_STEP_PATHS.ARTIFICIAL_ULTIMATE_BENEFICIAL_OWNER_PATH}`;
  } else if (region === 'ap' && hasControlOverManagementStakeholders) {
    return `${basePath}/${FLOW_STEP_PATHS.CONTROL_OVER_MANAGEMENT_PATH}`;
  } else if (isEntityTypePartnership && !isApplicantOnly) {
    return `${basePath}/${FLOW_STEP_PATHS.PARTNERS_PATH}`;
  } else if (isApplicant) {
    return `${basePath}/${FLOW_STEP_PATHS.APPLICANT_PATH}`;
  } else {
    return `${basePath}/${FLOW_STEP_PATHS.ULTIMATE_BENEFICIAL_OWNER_PATH}`;
  }
};
